import get from 'lodash/get';
import { INCIDENTS_STRATEGIES } from './incidents-detection-settings.constants';

export const validateInputs = (value, stateValue) => {
  const stateKey = get(stateValue, 'key');
  const stateTokenId = get(stateValue, 'api_token_id');
  const valueKey = get(value, 'key');
  if (stateKey === valueKey) return false;
  if (stateKey === INCIDENTS_STRATEGIES.REPORTED && !stateTokenId) {
    return false;
  }
  return true;
};

export const getAdditionalDataObject = ({
  radioValue,
  tokenExists,
  activeTokens
}) => ({
  api_token_id:
    radioValue === INCIDENTS_STRATEGIES.REPORTED && tokenExists
      ? activeTokens[0].id
      : null
});
